import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahReports } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { StatementBudgetsSummary, StatementBudgetsSummaryRow } from '~support-at-home/models/dashboard';

type Request = { statement_month: string; limit: number; offset: number };

interface StatementBudgetsSummaryResponse {
  rows: StatementBudgetsSummaryRow[];
  total: number;
  summary: StatementBudgetsSummary;
}

export const statementBudgetsSummaryApi = createApi({
  reducerPath: 'statementBudgetsSummaryApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahReports }),
  tagTypes: ['statement-budgets-summary'],
  endpoints: (builder) => ({
    getStatementBudgetsSummary: builder.query<StatementBudgetsSummaryResponse, Request>({
      query: (params) => ({ url: '/statement-budget-summary', method: 'GET', params }),
      providesTags: [{ type: 'statement-budgets-summary', id: 'LIST' }],
      transformResponse: (payload) => unwrap<StatementBudgetsSummaryResponse>(payload),
    }),
  }),
});

export const { useGetStatementBudgetsSummaryQuery } = statementBudgetsSummaryApi;
